import React, { Component } from 'react'
import { element, object } from 'prop-types'
import { RendererProvider } from 'react-fela'

class FelaProvider extends Component {
  static contextTypes = {
    renderer: object
  }

  render() {
    if (this.context.renderer) {
      return this.props.children
    }

    const renderer = this.props.renderer
    if (!renderer) return null
    return <RendererProvider renderer={renderer}>{this.props.children}</RendererProvider>
  }
}

FelaProvider.propTypes = {
  children: element.isRequired
}

FelaProvider.defaultProps = {
  renderer: null
}

export default FelaProvider
